<template>
  <path pid="0" d="M18.5 10h-3V8h3a1 1 0 001-1V3a1 1 0 00-1-1h-3a6 6 0 00-6 6v2h-2a1 1 0 00-1 1v4a1 1 0 001 1h2v7a1 1 0 001 1h4a1 1 0 001-1v-7h2a1 1 0 001-.76l1-4a1 1 0 00-1-1.24zm-1.78 4H14.5a1 1 0 00-1 1v7h-2v-7a1 1 0 00-1-1h-2v-2h2a1 1 0 001-1V8a4 4 0 014-4h2v2h-2a2 2 0 00-2 2v3a1 1 0 001 1h2.72z"/>
</template>
